import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Input from '../../../../components/Input';
import Label from '../../../../components/Label';
import messages from './messages';

import '../styles.css';

const NearestCity = ({ onChange, initialValue }) =>
  (
    <React.Fragment>
      {
        Object.keys(initialValue).filter((k) => initialValue[k]).map((key) => (
          <div styleName="field" key={key}>
            <Label styleName="menu-field-label" as="label" htmlFor={key}>
              <FormattedMessage {...messages[key]} />
            </Label>
            <Input
              fluid
              id={key}
              value={initialValue[key].value}
              onChange={(e, { value }) => {
                onChange(e, {
                  [key]: { ...initialValue[key], value },
                });
              }}
            />
          </div>
        ))
      }
    </React.Fragment>
  );

NearestCity.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default NearestCity;
